
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#A4A8C0","d":"M9 .26a1 1 0 01.25.7v8.81a1 1 0 01-.26.7 1 1 0 01-1.37 0 1 1 0 01-.25-.7V6.06H1.9v3.71a1 1 0 01-.26.7.93.93 0 01-.7.27.91.91 0 01-.68-.27 1 1 0 01-.26-.7V1A1 1 0 01.25.26.92.92 0 01.94 0a.94.94 0 01.7.26.94.94 0 01.26.74v3.5h5.42V1a1 1 0 01.25-.7.92.92 0 01.69-.3.92.92 0 01.74.26zM15.36 0a.91.91 0 01.64.25 1 1 0 01.25.71v8.13h1.58c.62 0 .93.253.93.76 0 .533-.3.797-.9.79h-5.07c-.607 0-.913-.263-.92-.79-.007-.527.3-.783.92-.77h1.56V2.25l-1.44.88a.78.78 0 01-.37.12A.66.66 0 0112 3a.93.93 0 01-.22-.6.75.75 0 01.39-.67L14.5.27c.256-.167.554-.26.86-.27z"}})])
          )
        }
      }
    